class CoffeeQuiz {
  constructor() {
    this.currentStep = 1;
    this.totalSteps = document.querySelectorAll('.quiz-step').length;
    this.answers = {};
    this.points = { 1: 0, 2: 0, 3: 0, 4: 0 };
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateProgress();
    this.updateNavigation();
  }

  bindEvents() {
    // Answer selection
    document.querySelectorAll('.answer-input').forEach(input => {
      input.addEventListener('change', (e) => {
        this.handleAnswerSelection(e);
      });
    });

    // Navigation buttons
    document.getElementById('nextBtn').addEventListener('click', () => {
      this.nextStep();
    });

    document.getElementById('prevBtn').addEventListener('click', () => {
      this.prevStep();
    });

    document.getElementById('submitBtn').addEventListener('click', () => {
      this.submitQuiz();
    });

    document.getElementById('retakeQuiz').addEventListener('click', () => {
      this.retakeQuiz();
    });
  }

  handleAnswerSelection(e) {
    const questionName = e.target.name;
    const answerValue = parseInt(e.target.value);
    
    // Remove selected class from all options in this question
    const currentStepElement = document.querySelector(`[data-step="${this.currentStep}"]`);
    if (currentStepElement) {
      const allOptions = currentStepElement.querySelectorAll('.answer-option');
      allOptions.forEach(option => option.classList.remove('selected'));
    }
    
    // Add selected class to the clicked option
    const clickedOption = e.target.closest('.answer-option');
    if (clickedOption) {
      clickedOption.classList.add('selected');
    }
    
    // Store the answer
    this.answers[questionName] = answerValue;
    
    // Update points - use the actual point value from the answer
    this.points[answerValue] = (this.points[answerValue] || 0) + 1;
    
    // Enable next button
    this.updateNavigation();
  }

  nextStep() {
    if (this.currentStep < this.totalSteps) {
      this.currentStep++;
      this.showStep(this.currentStep);
      this.updateProgress();
      this.updateNavigation();
    }
  }

  prevStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
      this.showStep(this.currentStep);
      this.updateProgress();
      this.updateNavigation();
    }
  }

  showStep(stepNumber) {
    // Hide all steps
    document.querySelectorAll('.quiz-step').forEach(step => {
      step.classList.remove('active');
    });

    // Show current step
    const currentStepElement = document.querySelector(`[data-step="${stepNumber}"]`);
    if (currentStepElement) {
      currentStepElement.classList.add('active');
    }
  }

  updateProgress() {
    const progressFill = document.getElementById('progressFill');
    const currentStepElement = document.getElementById('currentStep');
    const totalStepsElement = document.getElementById('totalSteps');
    
    const progressPercentage = (this.currentStep / this.totalSteps) * 100;
    progressFill.style.width = `${progressPercentage}%`;
    
    currentStepElement.textContent = this.currentStep;
    totalStepsElement.textContent = this.totalSteps;
  }

  updateNavigation() {
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');
    const submitBtn = document.getElementById('submitBtn');
    
    // Previous button
    prevBtn.disabled = this.currentStep === 1;
    
    // Check if current question is answered
    const currentQuestion = `q${this.currentStep}`;
    const isAnswered = this.answers[currentQuestion];
    
    if (this.currentStep === this.totalSteps) {
      // Last step - show submit button
      nextBtn.style.display = 'none';
      submitBtn.style.display = 'inline-block';
      submitBtn.disabled = !isAnswered;
    } else {
      // Not last step - show next button
      nextBtn.style.display = 'inline-block';
      submitBtn.style.display = 'none';
      nextBtn.disabled = !isAnswered;
    }
  }

  submitQuiz() {
    // Calculate personality type
    const personalityType = this.calculatePersonalityType();
    
    // Show results
    this.showResults(personalityType);
  }

  calculatePersonalityType() {
    // Original static scoring logic
    const comfortCount = this.points[1] || 0;
    const balancedCount = this.points[2] || 0;
    const adventurousCount = this.points[3] || 0;
    
    // Determine personality type based on original rules
    if (comfortCount >= 3) {
      return 'comfort';
    } else if (balancedCount >= 3) {
      return 'balanced';
    } else if (adventurousCount >= 3) {
      return 'adventurous';
    } else {
      // Split between categories - default to balanced
      return 'balanced';
    }
  }

  showResults(personalityType) {
    // Hide quiz and header, show results
    document.querySelector('.quiz-stepper').style.display = 'none';
    document.getElementById('quizResults').style.display = 'block';
    const quizHeader = document.querySelector('.quiz-header');
    if (quizHeader) quizHeader.style.display = 'none';
    
    // Populate results based on personality type
    this.populateResults(personalityType);
  }

  populateResults(personalityType) {
    const results = this.getPersonalityResults(personalityType);
    
    // Update personality type
    document.getElementById('personalityType').innerHTML = `
      <h3 class="personality-name">${results.name}</h3>
    `;
    
    // Update description
    document.getElementById('personalityDescription').innerHTML = `
      <p class="personality-text">${results.description}</p>
    `;
    
    // Show the appropriate product template
    this.showProductTemplate(personalityType);
  }

  showProductTemplate(personalityType) {
    const productsGrid = document.getElementById('productsGrid');
    const templateId = `${personalityType}-products`;
    const template = document.getElementById(templateId);
    
    if (template) {
      // Clear existing content
      productsGrid.innerHTML = '';
      
      // Get primary and secondary product cards from template
      const primaryCard = template.querySelector('.product-card.primary');
      const secondaryCard = template.querySelector('.product-card.secondary');
      
      if (primaryCard) {
        const clonedPrimary = primaryCard.cloneNode(true);
        clonedPrimary.style.display = '';
        productsGrid.appendChild(clonedPrimary);
      }
      
      if (secondaryCard) {
        const clonedSecondary = secondaryCard.cloneNode(true);
        clonedSecondary.style.display = '';
        productsGrid.appendChild(clonedSecondary);
      }
    } else {
      // Fallback if template not found
      productsGrid.innerHTML = `
        <div class="product-placeholder">
          <p>Product recommendations not available</p>
        </div>
      `;
    }
  }

  getPersonalityResults(type) {
    // Get settings from the page (these will be populated by Liquid)
    const settings = window.quizSettings || {};
    
    const results = {
      'comfort': {
        name: settings.comfort_name || 'Comfort & Cozy',
        description: settings.comfort_description || 'You\'re Comfort & Cozy. You know what you like - smooth, dependable, and deeply satisfying.',
        primary: {
          name: settings.comfort_primary_name || 'Espresso Corazon (Medium)',
          description: settings.comfort_primary_description || 'Millionaire\'s Mixture has been a Bloor West favourite for over 30 years: bold, rich, and unforgettable.',
          product: settings.comfort_primary_product
        },
        secondary: {
          name: settings.comfort_secondary_name || 'Millionaire\'s Mixture (Dark)',
          description: settings.comfort_secondary_description || 'A rich, bold blend that has been a favorite for over 30 years.',
          product: settings.comfort_secondary_product
        }
      },
      'balanced': {
        name: settings.balanced_name || 'Balanced & Everyday',
        description: settings.balanced_description || 'You\'re Balanced & Everyday. You like your coffee to hit the sweet spot: versatile, smooth, and never dull.',
        primary: {
          name: settings.balanced_primary_name || 'Guatemala Huehuetenango (Medium)',
          description: settings.balanced_primary_description || 'Our Guatemala Huehuetenango brings notes of brown sugar and spice, with a clean finish that fits any time of day.',
          product: settings.balanced_primary_product
        },
        secondary: {
          name: settings.balanced_secondary_name || 'Mocha Java (Dark)',
          description: settings.balanced_secondary_description || 'Or try Mocha Java, the world\'s oldest blend, pairing earthy Sumatra with fruity Ethiopia for a velvety, balanced cup.',
          product: settings.balanced_secondary_product
        }
      },
      'adventurous': {
        name: settings.adventurous_name || 'Adventurous & Bright',
        description: settings.adventurous_description || 'You\'re Adventurous & Bright. You love exploring flavours that spark curiosity.',
        primary: {
          name: settings.adventurous_primary_name || 'Ethiopia Yirgacheffe (Medium)',
          description: settings.adventurous_primary_description || 'Our Ethiopia Yirgacheffe is like sipping blueberry tea in a flower garden - floral, citrusy, endlessly sippable.',
          product: settings.adventurous_primary_product
        },
        secondary: {
          name: settings.adventurous_secondary_name || 'Mexico Chiapas (Dark)',
          description: settings.adventurous_secondary_description || 'Or go with Mexico Chiapas, warm and toasty like cinnamon bread from the oven, with just enough cocoa depth to keep things exciting.',
          product: settings.adventurous_secondary_product
        }
      }
    };
    
    return results[type] || results['balanced'];
  }

  retakeQuiz() {
    // Reset everything
    this.currentStep = 1;
    this.answers = {};
    this.points = { 1: 0, 2: 0, 3: 0, 4: 0 };
    
    // Clear all answers
    document.querySelectorAll('.answer-input').forEach(input => {
      input.checked = false;
    });
    
    // Show quiz and header, hide results
    document.querySelector('.quiz-stepper').style.display = 'block';
    document.getElementById('quizResults').style.display = 'none';
    const quizHeader = document.querySelector('.quiz-header');
    if (quizHeader) quizHeader.style.display = '';
    
    // Reset UI
    this.showStep(1);
    this.updateProgress();
    this.updateNavigation();
  }

}

// Initialize quiz when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CoffeeQuiz();
});
